module.exports = __webpack_public_path__ + "img/video_w.fc1664d6.svg";